import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidenavBarStoreService {
  private state = signal({
    isOpen: true,
    isSwitchingProvider: false
  });

  isOpen = computed(() => this.state().isOpen);
  isSwitchingProvider = computed(() => this.state().isSwitchingProvider);

  setIsOpen(isOpen: boolean): void {
    this.state.update(state => ({
      ...state,
      isOpen
    }));
  }

  setIsSwitchingProvider(isSwitchingProvider: boolean): void {
    this.state.update(state => ({
      ...state,
      isSwitchingProvider
    }));
  }
}
